import apiClient from '@/clients/apiClient';
import { saveAs } from 'file-saver';

export const getCustomerList = (
  page = 1,
  pageSize = 10,
  search = '',
  isVerified = '',
  referralSource = '',
  registeredPlatform = '',
  onboardingSteps = [],
  sortBy = '',
  orderBy = '',
  startAt = '',
  endAt = ''
) => {
  const params = new URLSearchParams({
    Page: page,
    PageSize: pageSize,
    Search: search,
    IsVerified: isVerified,
    referralSource: referralSource,
    RegisteredPlatform: registeredPlatform,
    CreatedStartAt: startAt,
    CreatedEndAt: endAt,
    'Sort.Sort_By': sortBy,
    'Sort.Order_By': orderBy,
  });

  if (onboardingSteps && onboardingSteps.length > 0) {
    onboardingSteps.forEach((step) => {
      params.append('OnboardingSteps', step);
    });
  }

  return apiClient.get(`users?${params.toString()}`);
};

export const getUnpaginatedCustomerList = (search = '') =>
  apiClient.get(`users/lite?Search=${search}`);

export const getCustomersNeedingVerification = (search = '') =>
  apiClient.get(`users/needing-verification?Search=${search}`);

export const getCustomerProfile = (id) => apiClient.get(`users/${id}`);

export const getKycChecklist = (id) => apiClient.get(`users/${id}/checklist`);

export const getCustomerLoans = (id) => apiClient.get(`/users/${id}/loan-requests`);

export const createCustomer = (data) => apiClient.post('users', data);

export const updateCustomer = (data, id) => apiClient.put(`users/${id}`, data);

export const getCustomersCount = () => apiClient.get('users/entities/count');

export const getCustomerBusinesses = (id) => apiClient.get(`users/${id}/businesses`);

export const getCustomerWallets = (userId) => apiClient.get(`users/${userId}/wallets`);

export const suspendCustomer = (userId) => apiClient.patch(`users/${userId}/suspend`);

export const reactivateCustomer = (userId) => apiClient.patch(`users/${userId}/re-enable`);

export const updateCustomerBvn = (data, id) => apiClient.put(`users/${id}/profile/bvn`, data);

export const verifyCustomerBVN = (userId) =>
  apiClient.post(`users/${userId}/bvn-information/verify`, {});

export const verifyKycItem = (data, userId) =>
  apiClient.put(`users/${userId}/verifykycitem`, data);

export const forceResetUserPassword = (userId) =>
  apiClient.post(`users/${userId}/force-password-reset`);

export const uploadCustomerDocument = (payload) =>
  apiClient.post(`users/${payload.userId}/profile/id-card`, payload.data);

export const getStates = () => apiClient.get('/users/states');

export const getLgas = (stateId) => apiClient.get(`users/states/${stateId}/lgas`);

export const uploadCustomerOtherDocument = (payload) =>
  apiClient.post(`users/${payload.userId}/profile/documents`, payload.data);

export const exportCustomersList = (
  type,
  page = 1,
  pageSize = 10,
  search = '',
  isVerified = '',
  referralSource = '',
  registeredPlatform = '',
  onboardingSteps = [],
  sortBy = '',
  orderBy = '',
  startAt = '',
  endAt = ''
) => {
  const params = new URLSearchParams({
    Page: page,
    PageSize: pageSize,
    Search: search,
    IsVerified: isVerified,
    referralSource: referralSource,
    RegisteredPlatform: registeredPlatform,
    CreatedStartAt: startAt,
    CreatedEndAt: endAt,
    'Sort.Sort_By': sortBy,
    'Sort.Order_By': orderBy,
  });

  if (onboardingSteps && onboardingSteps.length > 0) {
    onboardingSteps.forEach((step) => {
      params.append('OnboardingSteps', step);
    });
  }

  return apiClient
    .get(`users/export/${type}?${params.toString()}`, { responseType: 'blob' })
    .then((response) => {
      saveAs(response.data, `users.${type}`);
    });
};
export const updateCustomerProfile = (userId, data) =>
  apiClient.patch(`users/${userId}/profile`, data);
